import React from 'react';
import {useTranslation} from 'react-i18next';
import {Row, Col} from 'reactstrap';
import {Select} from '@/Form';
import {buildSelectOptions} from '@/components/Form/formHelper';

const ClientBirthday = () => {
  const {t: tr} = useTranslation('selection');

  return (
    <Row>
      <Col md={12}>
        <label>{tr('report:month')}</label>
        <Row>
          <Col md={2}>
            <Select name='month'>
              {buildSelectOptions(tr('month_options'))}
            </Select>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default ClientBirthday;
